import { CreateGuestGift, patchUpdateGuest } from '../../../services/api';
import { errorBannerFalse } from '../component/BusinessPreview';

// eslint-disable-next-line import/prefer-default-export
export const addToCartBusiness = ({
  e,
  voucherData,
  entityData,
  isEditMode,
  setErrorBanner,
  errorHandler,
  auth0Token,
}) => {
  let addcart;
  errorBannerFalse(setErrorBanner);
  const totalQty = voucherData.bussinessData?.reduce(
    (acc, val) => Number(acc) + Number(val.qty),
    0
  );
  if (totalQty > 400000) {
    errorHandler(setErrorBanner, 4);
    return;
  }
  const denominations = voucherData.bussinessData
    ?.filter((item) => item.qty > 0 && (item.amount > 0 || item.value > 0))
    .map((denomination) => ({
      amount:
        denomination.amount > 0 ? denomination.amount?.toString() : denomination.value?.toString(),
      quantity: denomination.qty,
    }));
  const payLoad = {
    sender: entityData?.name,
    message: voucherData.metadata?.message,
    entityId: entityData?.id,
    metadata: {
      name: voucherData?.metadata?.name,
      image: voucherData.metadata?.image,
      catergory: voucherData.metadata?.catergory,
    },
    addressee: {
      voucher: voucherData.businessEmail,
      password: voucherData.otherBusinessEmail || voucherData.businessEmail,
    },
    denominations,
  };
  if (isEditMode) {
    addcart = patchUpdateGuest('', voucherData.id, '', payLoad, auth0Token);
  } else {
    addcart = CreateGuestGift('', payLoad, '', auth0Token);
  }
  addcart
    .then((res) => {
      if (res.code === 200) {
        e.preventDefault();
        const windowVar = typeof window !== 'undefined' && window;
        windowVar.location.href = '/cart/';
      }
    })
    .catch(() => {
      errorHandler(setErrorBanner, 3);
    });
};
